import { RendererApiRoute } from "./routes";
import { postJson, sendBeaconJson } from "./transport";
import type {
  DynamicContentEntriesRequest,
  DynamicContentEntriesResponse,
  PopupTrackRequest,
  SubscriptionCouponValidateRequest,
  SubscriptionCouponValidateResponse,
  WhatsappCollectionEntriesRequest,
  WhatsappCollectionEntriesResponse,
} from "./types";

export interface RendererApiClient {
  fetchDynamicContentEntries: (
    request: DynamicContentEntriesRequest,
  ) => Promise<DynamicContentEntriesResponse | null>;
  fetchWhatsappCollectionEntries: (
    request: WhatsappCollectionEntriesRequest,
  ) => Promise<WhatsappCollectionEntriesResponse | null>;
  trackPopupEvent: (request: PopupTrackRequest) => void;
  /* Valida cupom exclusivo de CPF no servidor (CPF/validade). `null` = falha de rede
     ou servidor (não é recusa), para o consumidor distinguir "tente de novo". */
  validateSubscriptionCoupon: (
    request: SubscriptionCouponValidateRequest,
  ) => Promise<SubscriptionCouponValidateResponse | null>;
}

export const createRendererApiClient = ({ prefix }: { prefix: string }): RendererApiClient => {
  const buildUrl = (route: RendererApiRoute): string => `${prefix}${route}`;

  return {
    fetchDynamicContentEntries: (request) =>
      postJson<DynamicContentEntriesResponse>({
        url: buildUrl(RendererApiRoute.DYNAMIC_CONTENT_ENTRIES),
        body: request,
      }),
    fetchWhatsappCollectionEntries: (request) =>
      postJson<WhatsappCollectionEntriesResponse>({
        url: buildUrl(RendererApiRoute.WHATSAPP_COLLECTION_ENTRIES),
        body: request,
      }),
    trackPopupEvent: (request) => {
      if (typeof window === "undefined") return;
      sendBeaconJson({ url: buildUrl(RendererApiRoute.POPUPS_TRACK), body: request });
    },
    validateSubscriptionCoupon: (request) =>
      postJson<SubscriptionCouponValidateResponse>({
        url: buildUrl(RendererApiRoute.SUBSCRIPTION_COUPONS_VALIDATE),
        body: request,
      }),
  };
};
